import Button from "@imminently/decisively-ui/Button";
import Icon from "@imminently/decisively-ui/Icon";
import cn from "clsx";

export type RowActionProps = {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const RowAction = ({ className, style, onClick }: RowActionProps) => (
  <Button
    icon
    size="sm"
    intent="dark"
    variant={"contained"}
    label="Insert row"
    tooltip={false}
    className={cn("absolute left-[-4.5rem] z-[6]", className)}
    style={style}
    contentEditable={false}
    onClick={onClick}
  >
    <Icon name="add" />
  </Button>
);
